import FaceBookLoginComponent from './FacebookLoginComponent.js';
import GoogleLoginComponent from './GoogleLoginComponent.js';
import ReactFacebookLogin from 'react-facebook-login';
import config from '../../../config/config.json'
import { facebooklogin } from '../../lib/facebooklogin.js';

const FacebookGoogleLogin = (props) => {
    // console.log(props,"facebook");
    return (
        <div className='facebook_google_login'>
            {/* {props.siteData.site.facebook_login_key !== "" && <FaceBookLoginComponent btnText={props.theme == 'theme2' ? '' : "Login with Facebook"} imageSrc='images/facebook.svg' siteData={props.siteData.site} />} */}
            {props.siteData.site.google_login_key !== "" && <GoogleLoginComponent isSignUp={props.isSignUp} getSignUpForm={props.getSignUpForm} text={props.signupText || props.theme == 'theme2' ? '' : 'Login'} styles={"btn-google-icon"} siteData={props.siteData.site} theme={props.theme}/>}
            
        </div>
    )
}
export default FacebookGoogleLogin;